module.exports = __webpack_public_path__ + "img/link_icon.446a9a65.png";